import React from 'react';

import BackgroundImage from '../assets/background_start.png';
import BackgroundImageFrutas from '../assets/background_frutas_white.png';

import { useNavigate } from 'react-router-dom'

import {
    ArrowLeftOutlined,
    WhatsAppOutlined,
    MailOutlined,
    LinkOutlined
} from '@ant-design/icons'
import Atgc from '../assets/atgc.png';
import Clinicas from '../assets/clinicas.png';
import Cmw from '../assets/cmw.png';
import Fapergs from '../assets/fapergs.png';
import Nm from '../assets/nm.png';
import Recordati from '../assets/recordati.png';


import './Info.scss';

const Info = () => {
    let navigate = useNavigate()

    const onClickBack = () => {
        console.log('click')
        navigate('/', { replace: true })
    }
    return (
        <div className='info' style={{ backgroundImage: `url(${BackgroundImage})` }}>
            <div className='info__backButton'>
                <ArrowLeftOutlined className="info__icons" onClick={onClickBack} />
            </div>
            <div className='info__title'>
                <p style={{ paddingTop: 6 }}>Saiba Mais</p>
            </div>
            <div className='info__body'>
                <p>As <u>aminoacidopatias</u> fazem parte do grupo de condições genéticas dos erros
                    inatos do metalismo, que são <b>hereditárias</b> e causadas por alteração em um <b>gene</b> que
                    leva ao mau funcionamento de alguma via metabólica do organismo. Nesse caso, na via
                    metabólica da <b>proteína</b>.</p>
            </div>
            <div style={{ marginTop: 175 }}>
                <div className='info__bodysac'>
                    <p className='info__text'><b>Para mais informações sobre as aminoacidopatias, acesse os links:</b></p>
                </div>
                <div className='info__bodysac' style={{ marginTop: 40 }}>
                    <p className='info__text'><a href="https://www.sbteim.org.br/default.aspx" target="_blank">SBTEIM</a></p>
                </div>
                <div className='info__bodysac' style={{ marginTop: 10 }}>
                    <p className='info__text'><a href="https://www.sbgm.org.br/conteudo.aspx?id=9&amp;area=informacoes&amp;pagina=doenca" target="_blank">SBGM</a></p>
                </div>
                <div className='info__bodysac' style={{ marginTop: 10 }}>
                    <p className='info__text'><a href="https://www.orpha.net/consor/cgi-bin/Disease.php?lng=PT" target="_blank">ORPHA.NET</a></p>
                </div>
                <div className='info__bodysac' style={{ marginTop: 10 }}>
                    <p className='info__text'><a href="https://www.pkuday.org/about/" target="_blank">PKU Day</a></p>
                </div>
                <div className='info__bodysac' style={{ marginTop: 10 }}>
                    <p className='info__text'><a href="https://www.gov.br/saude/pt-br/composicao/saes/sangue/programa-nacional-da-
triagem-neonatal" target="_blank">Programa Nacional da Triagem Neonatal</a></p>
                </div>
                <div className='info__bodysac' style={{ marginTop: 20 }}>
                    <p className='info__text'><a href="https://app.powerbi.com/view?r=eyJrIjoiMzJmZTMzMmQtM2MzMS00Yjk3LTg2MT
MtZDlkN2Q0OGI0MWMxIiwidCI6ImI2N2FmMjNmLWMzZjMtNGQzNS04MGM3
LWI3MDg1ZjVlZGQ4MSJ9" target="_blank">Conteúdo de Fenilalanina em Alimentos</a></p>
                </div>
            </div>
            <div style={{ marginTop: 30 }}>
                <div className='info__bodysac'>
                    <p className='info__text'><b>Instagram: @aminoapp_</b></p>
                </div>
            </div>
            <div style={{ marginTop: 30 }}>
                <div className='info__bodysac'>
                    <p className='info__text'><b>Instagram: @nutricaometabolica</b></p>
                </div>
            </div>
            <div style={{ marginTop: 10 }}>
                <div className='info__bodysac'>
                    <p className='info__text'><b>Contatos de Associações de Apoio para pacientes e familiares em:</b></p>
                </div>
                <div className='info__bodysac' style={{ marginTop: 40 }}>
                    <p className='info__text'><a href="https://www.sbgm.org.br/associacao.aspx?area=informacoes&amp;pagina=associacao" target="_blank">SBGM</a></p>
                </div>
            </div>
            <div style={{ marginTop: 20 }}>
                <div className='info__bodysac'>
                    <p className='info__text'><b>Desenvolvedores:</b></p>
                </div>
                <img src={Nm} alt='' className='info__logo' />
                <img src={Atgc} alt='' className='info__logo' />
            </div>
            <div style={{ marginTop: 20 }}>
                <div className='info__bodysac'>
                    <p className='info__text'><b>Apoiadores:</b></p>
                </div>
                <img src={Fapergs} alt='' className='info__logo' />
                <img src={Clinicas} alt='' className='info__logo' />
                <img src={Recordati} alt='' className='info__logo' />
                <img src={Cmw} alt='' className='info__logo' />
            </div>
            <div style={{ marginTop: 20 }}>
                <div className='info__bodysac'>
                    <p className='info__text'><b>v1.1.2</b></p>
                </div>
            </div>
            <div className='info__footerImage' style={{ backgroundImage: `url(${BackgroundImageFrutas})` }} />
        </div>
    )
}

export default Info